import { Box, Fab, Modal, Tooltip, styled, Typography, Avatar, TextField, Stack, ButtonGroup, Button } from '@mui/material'
import React, { useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import ImageIcon from '@mui/icons-material/Image';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DateRangeIcon from '@mui/icons-material/DateRange';

const StyledModal = styled(Modal)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const UserBox = styled(Box)({
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom:"20px"
});

export const Add = () => {
    const [open, setOpen] = useState(false);
  return (
        <>
          <Tooltip onClick={e=>setOpen(true)}  title="Add a new Post" sx={{position:"fixed", bottom:20, left:{xs:"calc(50% - 25px)", md:30} }}>
                <Fab color="primary" aria-label="add">
                  <AddIcon />
                </Fab>
            </Tooltip>
            <StyledModal
                open={open}
                onClose={e=>setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
              <Box bgcolor={"background.default"} color={"text.primary"} width={400} height={280} p={3} borderRadius={5}>
                  <Typography variant="h6" color="gray" textAlign="center">Create post</Typography>
                  <UserBox>
                      <Avatar sx={{ width: 30, height: 30 }} src="https://www.garfield.com/static/2399b30a2146552d9f207cc20c08d7e1/396ff/garfield-left-homepage.webp" />
                      <Typography fontWeight={500} variant="span">Agus</Typography>
                  </UserBox>
                  <TextField
                      sx={{width:"100%"}}
                      id="standard-multiline-static"
                      multiline
                      rows={3}
                      placeholder="What's on your mind?"
                      variant="standard"
                  />
                  <Stack direction="row" gap={1} mt={2} mb={3}>
                        <EmojiEmotionsIcon color="primary"/>
                        <ImageIcon color="secondary"/>
                        <VideoCameraBackIcon color="success"/>
                        <PersonAddIcon color="error"/>
                  </Stack>
                  <ButtonGroup fullWidth variant="contained" aria-label="outlined primary button group">
                      <Button>Post</Button>
                      <Button sx={{width:"100px"}}><DateRangeIcon /></Button>
                    </ButtonGroup>
                </Box>
            </StyledModal>
        </>
  )
}
